import { Link } from "react-router-dom";
import { ToastOptions } from "react-toastify";
import { ICompany } from "../interfaces/models/ICompany";
import { toastSuccess } from "./toast";

const catalogToastOptions: ToastOptions = {
  position: "bottom-center",
  autoClose: 2500,
  closeButton: true,
};

export const notifyGuestSpeakerCreated = () => {
  toastSuccess("A new Guest Speaker has been created.", catalogToastOptions);
};

export const notifyCompanyCreated = (
  company: Pick<ICompany, "id" | "name" | "logo" | "squareLogo">
) => {
  toastSuccess(
    <span>
      A new{" "}
      <Link
        to={`/catalogs/company/edit/${company.id}`}
        state={company}
        className="underline font-semibold hover:opacity-80 inline mx-1"
      >
        Company
      </Link>
      {" "}has been created.
    </span>,
    catalogToastOptions
  );
};

export const notifyGuestSpeakerCreatedWithNewCompany = (
  company: Pick<ICompany, "id" | "name" | "logo" | "squareLogo">
) => {
  notifyGuestSpeakerCreated();
  notifyCompanyCreated(company);
};
